import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  GET_STATISTIC_HASH_CHIP_POOL_START,
    getStatisticHashChipPoolSuccess,
    getStatisticHashChipPoolFailed,
} from '../../actions/pools'

/**
 * get statistic pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getStatisticHashChipPoolsApi = (props) => {
  var uri = `/admin/hash-chip-redeemed/statistics`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetStatisticHashChipPools(action) {
  try {
    const response = yield call(getStatisticHashChipPoolsApi, action?.payload)
      yield put(getStatisticHashChipPoolSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
  } catch (error) {
    yield put(getStatisticHashChipPoolFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get StatisticHashChip pools
 */
export default function* watchGetStatisticHashChipPools() {
  yield takeLatest(GET_STATISTIC_HASH_CHIP_POOL_START, doGetStatisticHashChipPools)
}
